import { render, staticRenderFns } from "./VideoHotcodeBgmusic.vue?vue&type=template&id=ebbd0638&scoped=true&"
import script from "./VideoHotcodeBgmusic.vue?vue&type=script&lang=js&"
export * from "./VideoHotcodeBgmusic.vue?vue&type=script&lang=js&"
import style0 from "./VideoHotcodeBgmusic.vue?vue&type=style&index=0&id=ebbd0638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbd0638",
  null
  
)

export default component.exports